export default __webpack_public_path__ + "static/media/Ajman-free-zone.571ba951.png";